import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { EvaluatorService } from '@/infra/services/evaluator';

interface GetEvaluatorParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = EvaluatorService.getInstance();

export const useGetEvaluator = (params: GetEvaluatorParams) => {
	const isEnabled = validateUuid([params.company_id, params.organization_id, params.id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_EVALUATOR, params],
		queryFn: async () => Service.show(params),
		enabled: isEnabled
	});
};
